import { createBrowserRouter } from 'react-router-dom';
import { About } from "../About/About";
import App from "../App";
import { Home } from "../Home/Home";

const router = createBrowserRouter([
    {
      path: '/',
      element: <App />,
      children: [
        {
          path: '',
          element: <Home />,
        },
        {
          path: '/about',
          element: <About />,
        },

      ],
    },
  ]);
  
  export default router;